import configs from 'configs';
import { authHeaders } from '../authHeader';

const baseURL = configs.beApiUrl;

export const checkSeverUptime = async () => {
  const request = {
    method: 'GET',
    headers: await authHeaders(),
  };

  const response = await fetch(`${baseURL}/uptime-robot`, request);
  if (!response.ok) {
    const error = new Error(`Response status: ${response.status}`);
    error.response = response;
    throw error;
  }
};
